import {
  getDocs,
  query,
  orderBy,
  limit,
  doc,
  startAfter,
  collection,
  setDoc,
  where,
  getDoc,
  getCountFromServer,
  FieldPath,
  runTransaction,
  documentId,
} from "firebase/firestore";
import { db } from "../firebase";
import { useState, useEffect } from "react";
import "../../Resources/Css/sub.css";

const Post_per_page = 9;

// 문서의 길이 불러오기
export async function GetAllData(table) {
  const dataRef = collection(db, table);
  const dataCount = (await getCountFromServer(dataRef)).data().count;

  if (dataCount == 0) {
    // console.log("해당 테이블에 데이터가 없습니다.");
    return [];
  }

  return dataCount;
}

// 특정 컬렉션의 마지막 문서 불러오기(문서 id이름 생성용)
export async function GetLastDocId(table) {
  try {
    const lastDocId = await runTransaction(db, async (transaction) => {
      const docRef = collection(db, table);

      const q = query(docRef, orderBy("reg_time", "desc"), limit(1));
      const querySnapShot = await getDocs(q);

      if (!querySnapShot.empty) {
        const lastDoc = querySnapShot.docs[0];
        return lastDoc.id;
      } else {
        // console.log("컬렉션에 문서가 없습니다.");
        return null;
      }
    });

    return lastDocId;
  } catch (error) {
    // console.log(table, "컬렉션의 마지막 문서 id 호출 실패", error);
  }
}

// 특정 게시물 정보 가져오기
export async function GetData(data, id) {
  // console.log(data, id);
  try {
    const postRef = doc(db, data, id);

    const docSnap = await getDoc(postRef);

    // 문서가 존재하면 데이터를 반환
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      // console.log("해당 데이터가 없습니다");
      return null;
    }
  } catch (error) {
    // console.error("게시물 데이터 오류발생:", error);
    return false;
  }
}

// 현재 게시물 앞 뒤 정보 가져오기
export async function GetSomeData(data, tData) {
  // console.log(data, tData);
  try {
    let prevPost = null;
    let nextPost = null;

    const postRef = collection(db, data);

    const prevDocQuery = query(
      postRef,
      where("reg_time", "<", tData),
      orderBy("reg_time", "desc"),
      limit(1)
    );

    const nextDocQuery = query(
      postRef,
      where("reg_time", ">", tData),
      orderBy("reg_time", "asc"),
      limit(1)
    );

    // 앞 문서 데이터 가져오기
    const prevQuerySnapshot = await getDocs(prevDocQuery);
    if (!prevQuerySnapshot.empty) {
      const prevDoc = prevQuerySnapshot.docs[0];
      prevPost = { id: prevDoc.id, ...prevDoc.data() }; // 문서 데이터 추출
      // console.log("Previous Post: ", prevPost);
    } else {
      console.log("이전 게시물이 없습니다.");
    }

    // 뒤 문서 데이터 가져오기
    const nextQuerySnapshot = await getDocs(nextDocQuery);
    if (!nextQuerySnapshot.empty) {
      const nextDoc = nextQuerySnapshot.docs[0];
      nextPost = { id: nextDoc.id, ...nextDoc.data() }; // 문서 데이터 추출
      // console.log("Next Post: ", nextPost);
    } else {
      console.log("다음 게시물이 없습니다.");
    }

    // 결과를 반환
    return { prevPost, nextPost };
  } catch (error) {
    console.log("앞 뒤 게시물 호출 실패", error);
  }
}

// 언론 DB 최신 4개 호출(메인페이지용)
/**
 * Resolve the thumbnail for a news/board entry. Prefers the dedicated
 * cover_img set in the admin form, then falls back to the first <img> in the
 * body content, then the bundled placeholder.
 */
export function getNewsThumbnail(news) {
  if (news && typeof news.cover_img === "string" && news.cover_img.trim()) {
    return news.cover_img.trim();
  }
  const content = news && news.content;
  if (typeof content === "string") {
    const match = content.match(/<img[^>]+src=["']([^"']+)["']/i);
    if (match && match[1]) return match[1];
  }
  return "/images/slider.png";
}

export async function GetNewestNews() {
  const newsRef = collection(db, "news"); // "news" 컬렉션 참조
  const q = query(newsRef, orderBy("reg_time", "desc"), limit(4));
  const querySnapshot = await getDocs(q); // 컬렉션에서 문서 가져오기

  if (querySnapshot.empty) {
    // console.log("No documents found.");
    return [];
  }

  // 문서 데이터를 배열로 변환
  const newsList = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(), // 문서 데이터
  }));

  return newsList;
}

// 언론 DB 호출(게시판용)
export async function GetNewsData(page = 1, lastVisible = null, nextFirst) {
  // 1페이지 당 10페이지 호출
  const postsPerPage = 9;
  const postRef = collection(db, "news");

  if (lastVisible == null) {
    nextFirst = 0;
  }

  let q;

  if (page == 1) {
    q = query(postRef, orderBy("reg_time", "desc"), limit(postsPerPage));
  } else {
    q = query(
      postRef,
      orderBy("reg_time", "desc"),
      startAfter(lastVisible),
      limit(postsPerPage)
    );
  }

  const querySnapShotAll = (
    await getCountFromServer(postRef, orderBy("reg_time", "desc"))
  ).data().count;

  const querySnapShot = await getDocs(q);

  const postsData = querySnapShot.docs.map((doc, index) => {
    const docData = doc.data();
    return {
      id: doc.id,
      ...docData,
      overallIndex:
        page == 1 ? querySnapShotAll - index : nextFirst - (index + 1),
    };
  });

  const lastVisibleDoc = querySnapShot.docs[querySnapShot.docs.length - 1];
  const lastPost =
    postsData.length > 0 ? postsData[postsData.length - 1].overallIndex : null;
  // console.log(lastPost.overallIndex);

  return { postsData, lastVisibleDoc, querySnapShotAll, lastPost };
}

// 언론 db 검색
export async function GetNewsKeyword(
  keyword,
  page = 1,
  lastVisible = null,
  nextFirst
) {
  // console.log("찾을키워드: ", keyword);

  if (lastVisible == null) {
    nextFirst = 0;
  }

  const postsPerPage = 9;
  const postRef = collection(db, "news");

  // 페이지네이션 쿼리 준비
  let q1;
  let q2;

  if (page == 1) {
    q1 = query(
      postRef,
      where("title", ">=", keyword),
      where("title", "<=", keyword + "\uf8ff"),
      orderBy("reg_time", "desc"),
      limit(postsPerPage) // 첫 페이지일 때
    );

    q2 = query(
      postRef,
      where("content_txt", ">=", keyword),
      where("content_txt", "<=", keyword + "\uf8ff"),
      orderBy("reg_time", "desc"),
      limit(postsPerPage) // 첫 페이지일 때
    );
  } else {
    q1 = query(
      postRef,
      where("title", ">=", keyword),
      where("title", "<=", keyword + "\uf8ff"),
      orderBy("reg_time", "desc"),
      startAfter(lastVisible), // 마지막 visible 문서 이후부터 시작
      limit(postsPerPage)
    );

    q2 = query(
      where("content_txt", ">=", keyword),
      where("content_txt", "<=", keyword + "\uf8ff"),
      orderBy("reg_time", "desc"),
      startAfter(lastVisible), // 마지막 visible 문서 이후부터 시작
      limit(postsPerPage)
    );
  }

  let allQ1 = query(
    postRef,
    where("title", ">=", keyword),
    where("title", "<=", keyword + "\uf8ff"),
    orderBy("reg_time", "desc")
  );

  let allQ2 = query(
    postRef,
    where("content_txt", ">=", keyword),
    where("content_txt", "<=", keyword + "\uf8ff"),
    orderBy("reg_time", "desc")
  );

  // 전체 데이터 가져오기
  // 조건 1, 2의 쿼리 병렬조합
  const [resSnapDocs1, resSnapDocs2] = await Promise.all([
    getDocs(q1),
    getDocs(q2),
  ]);

  const allDocs = [
    ...resSnapDocs1.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
    ...resSnapDocs2.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
  ];

  const uniqueDocs = Array.from(new Set(allDocs.map((doc) => doc.id))).map(
    (id) => allDocs.find((doc) => doc.id === id)
  );

  // 전체 데이터 병렬조합
  const [rsaDocs1, rsaDocs2] = await Promise.all([
    getDocs(allQ1),
    getDocs(allQ2),
  ]);

  const rsAllDocs = [
    ...rsaDocs1.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
    ...rsaDocs2.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
  ];

  const allUniqueDocs = Array.from(new Set(rsAllDocs.map((doc) => doc.id))).map(
    (id) => allDocs.find((doc) => doc.id === id)
  ).length;

  // 데이터를 구성하여 반환
  const postsResData = uniqueDocs.map((doc, index) => ({
    id: doc.id,
    ...doc,
    overallIndex: page == 1 ? allUniqueDocs - index : nextFirst - (index + 1),
  }));

  const lastResVisibleDoc = uniqueDocs[uniqueDocs.length - 1];
  const lastResPost = postsResData[postsResData.length - 1].overallIndex;

  return { postsResData, lastResVisibleDoc, allUniqueDocs, lastResPost };
}

//공지사항 DB 호출(게시판용)
export async function GetInformData(page = 1, lastVisible = null, nextFirst) {
  // 1페이지 당 10페이지 호출
  const postsPerPage = 10;
  const postRef = collection(db, "inform");

  if (lastVisible == null) {
    nextFirst = 0;
  }

  let q;

  if (page == 1) {
    q = query(postRef, orderBy("reg_time", "desc"), limit(postsPerPage));
  } else {
    q = query(
      postRef,
      orderBy("reg_time", "desc"),
      startAfter(lastVisible),
      limit(postsPerPage)
    );
  }

  const querySnapShotAll = (
    await getCountFromServer(postRef, orderBy("reg_time", "desc"))
  ).data().count;

  const querySnapShot = await getDocs(q);
  const postsData = querySnapShot.docs.map((doc, index) => {
    const docData = doc.data();
    return {
      id: doc.id,
      ...docData,
      overallIndex:
        page == 1 ? querySnapShotAll - index : nextFirst - (index + 1),
    };
  });

  const lastVisibleDoc = querySnapShot.docs[querySnapShot.docs.length - 1];
  const lastPost =
    postsData.length > 0 ? postsData[postsData.length - 1].overallIndex : null;
  // console.log(lastPost.overallIndex);

  return { postsData, lastVisibleDoc, querySnapShotAll, lastPost };
}

// 공지DB 검색
export async function GetInformKeyword(
  keyword,
  page = 1,
  lastVisible = null,
  nextFirst
) {
  if (lastVisible == null) {
    nextFirst = 0;
  }

  const postsPerPage = 10;
  const postRef = collection(db, "inform");

  // 페이지네이션 쿼리 준비
  let q1;
  let q2;

  if (page == 1) {
    q1 = query(
      postRef,
      where("title", ">=", keyword),
      where("title", "<=", keyword + "\uf8ff"),
      orderBy("reg_time", "desc"),
      limit(postsPerPage) // 첫 페이지일 때
    );

    q2 = query(
      postRef,
      where("content_txt", ">=", keyword),
      where("content_txt", "<=", keyword + "\uf8ff"),
      orderBy("reg_time", "desc"),
      limit(postsPerPage) // 첫 페이지일 때
    );
  } else {
    q1 = query(
      postRef,
      where("title", ">=", keyword),
      where("title", "<=", keyword + "\uf8ff"),
      orderBy("reg_time", "desc"),
      startAfter(lastVisible), // 마지막 visible 문서 이후부터 시작
      limit(postsPerPage)
    );

    q2 = query(
      where("content_txt", ">=", keyword),
      where("content_txt", "<=", keyword + "\uf8ff"),
      orderBy("reg_time", "desc"),
      startAfter(lastVisible), // 마지막 visible 문서 이후부터 시작
      limit(postsPerPage)
    );
  }

  let allQ1 = query(
    postRef,
    where("title", ">=", keyword),
    where("title", "<=", keyword + "\uf8ff"),
    orderBy("reg_time", "desc")
  );

  let allQ2 = query(
    postRef,
    where("content_txt", ">=", keyword),
    where("content_txt", "<=", keyword + "\uf8ff"),
    orderBy("reg_time", "desc")
  );

  // 전체 데이터 가져오기
  // 조건 1, 2의 쿼리 병렬조합
  const [resSnapDocs1, resSnapDocs2] = await Promise.all([
    getDocs(q1),
    getDocs(q2),
  ]);

  const allDocs = [
    ...resSnapDocs1.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
    ...resSnapDocs2.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
  ];

  const uniqueDocs = Array.from(new Set(allDocs.map((doc) => doc.id))).map(
    (id) => allDocs.find((doc) => doc.id === id)
  );

  // 전체 데이터 병렬조합
  const [rsaDocs1, rsaDocs2] = await Promise.all([
    getDocs(allQ1),
    getDocs(allQ2),
  ]);

  const rsAllDocs = [
    ...rsaDocs1.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
    ...rsaDocs2.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
  ];

  const allUniqueDocs = Array.from(new Set(rsAllDocs.map((doc) => doc.id))).map(
    (id) => allDocs.find((doc) => doc.id === id)
  ).length;

  // 데이터를 구성하여 반환
  const postsResData = uniqueDocs.map((doc, index) => ({
    id: doc.id,
    ...doc,
    overallIndex: page == 1 ? allUniqueDocs - index : nextFirst - (index + 1),
  }));

  const lastResVisibleDoc = uniqueDocs[uniqueDocs.length - 1];
  const lastResPost = postsResData[postsResData.length - 1].overallIndex;

  return { postsResData, lastResVisibleDoc, allUniqueDocs, lastResPost };
}

// 채용공고 DB 호출(게시판용)
export async function GetHiringData() {
  const getHiringDB = await getDocs(collection(db, "hiring"));

  const hiringData = getHiringDB.docs.map((hire) => ({
    id: hire.id,
    ...hire.data(),
  }));

  return hiringData;
}

// 채용 DB 전체 호출

// 특정 채용 DB 호출

// 문의사항 DB 호출(게시판용)
export async function GetInquiryData(page = 1, lastVisible = null) {
  // 1페이지 당 10페이지 호출
  const postsPerPage = 10;
  const postRef = collection(db, "inquiry");

  let q;

  if (page == 1) {
    q = query(postRef, orderBy("reg_time", "desc"), limit(postsPerPage));
  } else {
    q = query(
      postRef,
      orderBy("reg_time", "desc"),
      startAfter(lastVisible),
      limit(postsPerPage)
    );
  }
  const querySnapShotAll = (
    await getCountFromServer(postRef, orderBy("reg_time", "desc"))
  ).data().count;

  const querySnapShot = await getDocs(q);

  const postsData = [];

  // 각 게시글에 대한 서브컬렉션("comments") 유무 확인
  for (const docSnapshot of querySnapShot.docs) {
    const docData = docSnapshot.data();
    const postId = docSnapshot.id;

    // 해당 게시글에 대한 'comments' 서브컬렉션 참조
    const commentsRef = collection(db, "inquiry", postId, "comments");
    const commentsSnapshot = await getDocs(commentsRef);

    // 서브컬렉션 유무 확인 (댓글이 하나라도 있으면 true)
    const hasComments = !commentsSnapshot.empty;

    postsData.push({
      id: postId,
      ...docData,
      hasComments: hasComments, // 서브컬렉션 존재 여부 추가
      overallIndex:
        page == 1
          ? querySnapShotAll - postsData.length
          : querySnapShot.size - postsData.length,
    });
  }

  const totalSize = querySnapShotAll;
  const lastVisibleDoc = querySnapShot.docs[querySnapShot.docs.length - 1];

  return { postsData, lastVisibleDoc, totalSize };
}

// 문의 DB 전체 호출

// 특정 문의 DB 호출

// fAQ DB 호출
export async function GetFAQData(page = 1, lastVisible = null) {
  // 1페이지 당 5개의 게시물 호출
  const postsPerPage = 5; // 페이지당 게시물 수
  const postRef = collection(db, "faq");
  let q;
  if (page == 1) {
    q = query(postRef, orderBy("reg_time"), limit(postsPerPage));
  } else {
    q = query(
      postRef,
      orderBy("reg_time"),
      startAfter(lastVisible),
      limit(postsPerPage)
    );
  }
  const querySnapShotAll = await getDocs(postRef);
  const querySnapshot = await getDocs(q);
  const postsData = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
  const totalSize = querySnapShotAll.size;
  const lastVisibleDoc = querySnapshot.docs[querySnapshot.docs.length - 1];
  return { postsData, lastVisibleDoc, totalSize };
}
// fAQ DB 호출(챗봇 응답용)
export async function FaqForChatbot() {
  try {
    const docRef = collection(db, "faq");
    const q = query(docRef);
    const querySnapshot = await getDocs(q);

    const result = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      result.push({
        title: data.title,
        content: data.content,
      });
    });

    return result;
  } catch (error) {
    // console.log("faq 질문답변 출력 오류", error);
    return [];
  }
}

// 게시글에 댓글 불러오기
export async function GetPostComment(
  table,
  post,
  page = 1,
  lastVisible = null
) {
  // console.log(table);
  // console.log(post);
  const docRef = collection(db, table, post, "comments");

  let q;

  if (page == 1) {
    q = query(docRef, orderBy("commentData.reg_time"), limit(10));
  } else {
    q = query(
      docRef,
      orderBy("commentData.reg_time"),
      startAfter(lastVisible),
      limit(10)
    );
  }

  // 전체 댓글 수 가져오기
  const querySnapShotAllSize = (await getCountFromServer(docRef)).data().count;

  const querySnapShot = await getDocs(q);

  // 쿼리된 데이터가 있는지 확인
  const postData = querySnapShot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  let lastVisibleDoc;
  if (postData.length > 0) {
    lastVisibleDoc = postData[postData.length - 1];
  } else {
    lastVisibleDoc = null;
  }

  return { postData, lastVisibleDoc, querySnapShotAllSize };
}

// 보여줄 팝업 갯수 호출
export async function ShowPopupCount() {
  const docRef = doc(db, "popupCount", "popupCount1");
  // 해당 팝업 갯수 문서에서 갯수만 꺼내오기
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    const count = docSnap.data().count;
    return count;
  } else {
    // console.log("팝업 카운트가 존재하지 않습니다.");
    return 0;
  }
}

// 메인화면에 나타날 팝업
export async function ShowPopup(count) {
  const postRef = collection(db, "popup");
  const q = query(
    postRef,
    where("popup_yn", "==", "Y"),
    orderBy("reg_time", "desc"),
    limit(count)
  );

  const querySnapShot = await getDocs(q);

  const postsData = querySnapShot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  return postsData;
}

// 팝업 데이터 가져오기
export async function GetPopupData(page = 1, lastVisible = null, nextFirst) {
  // 1페이지당 10페이지 호출
  const postsPerPage = 10;
  const postRef = collection(db, "popup");

  if (lastVisible == null) {
    nextFirst = 0;
  }

  let q;

  if (page == 1) {
    q = query(postRef, orderBy("reg_time", "desc"), limit(postsPerPage));
  } else {
    q = query(
      postRef,
      orderBy("reg_time", "desc"),
      startAfter(lastVisible),
      limit(postsPerPage)
    );
  }

  const querySnapShotAll = (
    await getCountFromServer(postRef, orderBy("reg_time", "desc"))
  ).data().count;

  const querySnapShot = await getDocs(q);

  const postsData = querySnapShot.docs.map((doc, index) => {
    const docData = doc.data();
    return {
      id: doc.id,
      ...docData,
      overallIndex:
        page == 1 ? querySnapShotAll - index : nextFirst - (index + 1),
    };
  });

  const lastVisibleDoc = querySnapShot.docs[querySnapShot.docs.length - 1];
  const lastPost =
    postsData.length > 0 ? postsData[postsData.length - 1].overallIndex : null;
  // console.log(lastPost.overallIndex);

  return { postsData, lastVisibleDoc, querySnapShotAll, lastPost };
}

// popup 검색
export async function GetPopupKeyword(
  keyword,
  page = 1,
  lastVisible = null,
  nextFirst
) {
  // console.log("찾을키워드: ", keyword);
  if (lastVisible == null) {
    nextFirst = 0;
  }

  const postsPerPage = 10;
  const postRef = collection(db, "popup");

  // 페이지네이션 쿼리 준비
  let q1;
  let q2;

  if (page == 1) {
    q1 = query(
      postRef,
      where("title", ">=", keyword),
      where("title", "<=", keyword + "\uf8ff"),
      orderBy("reg_time", "desc"),
      limit(postsPerPage) // 첫 페이지일 때
    );

    q2 = query(
      postRef,
      where("content_txt", ">=", keyword),
      where("content_txt", "<=", keyword + "\uf8ff"),
      orderBy("reg_time", "desc"),
      limit(postsPerPage) // 첫 페이지일 때
    );
  } else {
    q1 = query(
      postRef,
      where("title", ">=", keyword),
      where("title", "<=", keyword + "\uf8ff"),
      orderBy("reg_time", "desc"),
      startAfter(lastVisible), // 마지막 visible 문서 이후부터 시작
      limit(postsPerPage)
    );

    q2 = query(
      where("content_txt", ">=", keyword),
      where("content_txt", "<=", keyword + "\uf8ff"),
      orderBy("reg_time", "desc"),
      startAfter(lastVisible), // 마지막 visible 문서 이후부터 시작
      limit(postsPerPage)
    );
  }

  let allQ1 = query(
    postRef,
    where("title", ">=", keyword),
    where("title", "<=", keyword + "\uf8ff"),
    orderBy("reg_time", "desc")
  );

  let allQ2 = query(
    postRef,
    where("content_txt", ">=", keyword),
    where("content_txt", "<=", keyword + "\uf8ff"),
    orderBy("reg_time", "desc")
  );

  // 전체 데이터 가져오기
  // 조건 1, 2의 쿼리 병렬조합
  const [resSnapDocs1, resSnapDocs2] = await Promise.all([
    getDocs(q1),
    getDocs(q2),
  ]);

  const allDocs = [
    ...resSnapDocs1.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
    ...resSnapDocs2.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
  ];

  const uniqueDocs = Array.from(new Set(allDocs.map((doc) => doc.id))).map(
    (id) => allDocs.find((doc) => doc.id === id)
  );

  // 전체 데이터 병렬조합
  const [rsaDocs1, rsaDocs2] = await Promise.all([
    getDocs(allQ1),
    getDocs(allQ2),
  ]);

  const rsAllDocs = [
    ...rsaDocs1.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
    ...rsaDocs2.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
  ];

  const allUniqueDocs = Array.from(new Set(rsAllDocs.map((doc) => doc.id))).map(
    (id) => allDocs.find((doc) => doc.id === id)
  ).length;

  // 데이터를 구성하여 반환
  const postsResData = uniqueDocs.map((doc, index) => ({
    id: doc.id,
    ...doc,
    overallIndex: page == 1 ? allUniqueDocs - index : nextFirst - (index + 1),
  }));

  const lastResVisibleDoc = uniqueDocs[uniqueDocs.length - 1];
  const lastResPost = postsResData[postsResData.length - 1].overallIndex;

  return { postsResData, lastResVisibleDoc, allUniqueDocs, lastResPost };
}
